import React, { FC } from 'react';

import { useTheme } from '@mui/material';

import { Svg } from '~/assets/icons/styles';
import { OneColorIconProps } from '~/assets/icons/types';

const CaseStudyIcon: FC<OneColorIconProps> = ({ color, ...rest }) => {
  const theme = useTheme();
  const svgColor = color || theme.palette.common.white;

  return (
    <Svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      svgColor={svgColor}
      {...rest}
    >
      <path
        d="M16.1301 15.9339C16.826 15.2378 17.2564 14.2762 17.2564 13.2141C17.2564 11.0895 15.5341 9.36719 13.4094 9.36719C11.2848 9.36719 9.5625 11.0895 9.5625 13.2141C9.5625 15.3387 11.2848 17.0611 13.4094 17.0611C14.472 17.0611 15.4339 16.6303 16.1301 15.9339Z"
        fill="transparent"
        fillOpacity="0.33"
      />
      <path
        d="M19.1666 18.8558L16.1291 15.9329M17.2564 13.2141C17.2564 15.3387 15.5341 17.0611 13.4094 17.0611C11.2848 17.0611 9.5625 15.3387 9.5625 13.2141C9.5625 11.0895 11.2848 9.36719 13.4094 9.36719C15.5341 9.36719 17.2564 11.0895 17.2564 13.2141Z"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path d="M13.875 4.16797L12.375 4.16797" stroke="currentColor" strokeLinecap="round" />
      <path d="M9.375 4.16797L4.875 4.16797" stroke="currentColor" strokeLinecap="round" />
      <path d="M13.875 7.1875L4.875 7.1875" stroke="currentColor" strokeLinecap="round" />
      <path
        d="M16.5625 7.65625V3.25C16.5625 2.14543 15.6671 1.25 14.5625 1.25H4.1875C3.08293 1.25 2.1875 2.14543 2.1875 3.25V15.5C2.1875 16.6046 3.08293 17.5 4.1875 17.5H9.20403"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </Svg>
  );
};

export default CaseStudyIcon;
